export const MenuIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={25}
            viewBox="0 0 24 25"
            fill="none"
        >
            <path
                d="M2 4.98047H18V6.98047H2V4.98047Z"
                fill="#FCFCFC"
                fillOpacity="0.8"
            />
            <path
                d="M2 11.9805H22V13.9805H2V11.9805Z"
                fill="#FCFCFC"
                fillOpacity="0.8"
            />
            <path
                d="M2 18.9805H18V20.9805H2V18.9805Z"
                fill="#FCFCFC"
                fillOpacity="0.8"
            />
        </svg>
    )
}